import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import de from "./locales/de.json";

const STORAGE_KEY = "ui_locale";
const SUPPORTED_LANGS = ["en", "fr", "es", "de"];

function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  } catch (_) {}
  return null;
}

function getBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage || "";
  const code = lang.split("-")[0].toLowerCase();
  if (SUPPORTED_LANGS.includes(code)) return code;
  return "en";
}

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGS,
  lng: getStoredLanguage() || getBrowserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (_) {}
});

export default i18n;
export { STORAGE_KEY, SUPPORTED_LANGS };
